
export const renderTypeEnum = {
  PerParticipant: 'PerParticipant',
  PerRoom: 'PerRoom',
  PerBooking: 'PerBooking'
}
